module.exports = __webpack_public_path__ + "static/img/9.39f43801.jpg";